import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";
import { useSelector } from "react-redux";

//Hook para cacheLoader
export const fetchEventosContingencia = async (id_empresa) => {
  if (!id_empresa) {
    console.warn("⚠️ `id_empresa` no es válido en fetchEventosContingencia:", id_empresa);
    return [];
  }

  try {
    const response = await api.get(`/${id_empresa}/eventoContingencia`);
    return response.data;
  } catch (error) {
    console.error("❌ Error en la petición:", error);
    return [];
  }
};

// Hook reutilizable con React Query
export const useEventosContingencia = () => {
  const { empresaSeleccionada } = useSelector((state) => state.auth);
  const id_empresa = empresaSeleccionada?.id; // ✅ Asegurar que existe un `id_empresa`

  return useQuery({
    queryKey: ["eventos_contingencia", id_empresa],
    queryFn: () => (id_empresa ? fetchEventosContingencia(id_empresa) : Promise.resolve([])),
    enabled: !!id_empresa,
  });
};

export const useEventoContingenciaById = (id_evento_contingencia) => {
  const { empresaSeleccionada } = useSelector((state) => state.auth);
  const id_empresa = empresaSeleccionada?.id;

  return useQuery({
    queryKey: ["evento_contingencia", id_empresa, id_evento_contingencia],
    queryFn: async () => {
      try {
        const { data } = await api.get(`/${id_empresa}/eventoContingencia/${id_evento_contingencia}`);
        return data;
      } catch (error) {
        console.error("❌ Error al obtener comprobante:", error);
        throw new Error("No se pudo obtener el comprobante");
      }
    },
    staleTime: 30000, // Cachea los datos por 60s para evitar múltiples llamadas innecesarias
    refetchOnWindowFocus: false, // No recarga automáticamente al enfocar la ventana
    enabled: !!id_empresa && !!id_evento_contingencia,
  });
};
